// This service is useful to highlight the questions or assessments
// which are not required but should be highlighted for some reason
// to attract user's attention to them
export default class HighlightElementsService {
  private ids: Set<number> = new Set()

  addIds(ids: number[]) {
    ids.forEach(id => this.ids.add(id))
  }

  getIds(): number[] {
    return [...this.ids]
  }

  deleteIds(ids: number[]) {
    ids.forEach(id => this.ids.delete(id))
  }

  reset() {
    this.ids.clear()
  }
}
